import type { PropsWithChildren } from 'react';
import React, { useContext, useMemo } from 'react';
import type { EntityName, EntitySecurity } from '../../types';
import { EntitySecurityContext } from '../contexts/EntitySecurityContext';

export type EntitySecurityProviderProps = PropsWithChildren & {
    entityName: EntityName;
    entitySecurity: EntitySecurity;
};

export default function EntitySecurityProvider({ entityName, entitySecurity, children }: EntitySecurityProviderProps) {
    const parentEntitySecurity = useContext(EntitySecurityContext);

    const contextValue = useMemo(() => {
        const parentEntitySecurityContexts = parentEntitySecurity?.entitySecurityContexts ?? [];

        const value = {
            // Keep nearest provider at index 0, then walk up the tree.
            entitySecurityContexts: [{ entityName, entitySecurity }, ...parentEntitySecurityContexts]
        };

        return value;
    }, [entityName, entitySecurity, parentEntitySecurity?.entitySecurityContexts]);

    return <EntitySecurityContext value={contextValue}>{children}</EntitySecurityContext>;
}
